import React from 'react';
import { projects } from './projects';
import Project from './Project';
import "./projectList.css";

const ProjectList = () => {
  return (
  <section className="ProjectList">
        <div className="ProjectContainer">
            {projects.map((proj) =>{
                return <Project key={projects.indexOf(proj)}{...proj}></Project>
            })}
        </div>
    </section>
  )
};

export default ProjectList;
